/**
 * Pages that anonymous visitors (guests) open: they must never load the staff session, show the staff
 * shell, or be bounced to /login. Keep in sync with the bypass list in src/proxy.ts.
 */
const PUBLIC_PREFIXES = ["/q/", "/guest/", "/feedback/", "/site/", "/pay/", "/onboard/"];

export function isPublicPath(pathname: string): boolean {
  return (
    pathname === "/login" ||
    pathname === "/landing" ||
    pathname === "/reset-password" ||
    PUBLIC_PREFIXES.some((p) => pathname.startsWith(p)) ||
    /^\/booking-sites\/[^/]+\/preview\/?$/.test(pathname)
  );
}

/** Public pages that need no staff session at all (the staff preview does, so it is excluded here). */
export function skipsStaffSession(pathname: string): boolean {
  return pathname === "/login" || pathname === "/landing" || pathname === "/reset-password" || PUBLIC_PREFIXES.some((p) => pathname.startsWith(p));
}
